import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MONTHS } from "@/lib/dates";

const sel = "h-9 rounded-md border border-input bg-transparent px-2 text-sm";

export const DateFields = ({ label, kind, form, set }) => {
  const month = form[`${kind}_month`] ?? "";
  return (
    <div data-testid={`${kind}-date-fields`}>
      <Label>{label}</Label>
      <div className="flex gap-2">
        <select className={`${sel} w-16`} value={form[`${kind}_day`] ?? ""} disabled={!month}
          onChange={e => set(`${kind}_day`, e.target.value ? Number(e.target.value) : null)} data-testid={`${kind}-day-select`}>
          <option value="">Jour</option>
          {Array.from({ length: 31 }, (_, i) => <option key={i + 1} value={i + 1}>{i + 1}</option>)}
        </select>
        <select className={`${sel} flex-1`} value={month}
          onChange={e => { const v = e.target.value ? Number(e.target.value) : null; set(`${kind}_month`, v); if (!v) set(`${kind}_day`, null); }}
          data-testid={`${kind}-month-select`}>
          <option value="">Mois</option>
          {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
        </select>
        <Input type="number" placeholder="Année" className="w-24" value={form[`${kind}_year`] ?? ""}
          onChange={e => set(`${kind}_year`, e.target.value)} data-testid={`${kind}-year-input`} />
      </div>
      <label className="flex items-center gap-2 text-xs text-[#6E5B4F] mt-1">
        <input type="checkbox" checked={!!form[`${kind}_year_approx`]} onChange={e => set(`${kind}_year_approx`, e.target.checked)}
          data-testid={`${kind}-year-approx`} /> Date approximative (« vers »)
      </label>
      <p className="text-[11px] text-[#6E5B4F] mt-0.5">Laissez jour ou mois vides s'ils sont inconnus.</p>
    </div>
  );
};

export default DateFields;
